import { RouterProvider } from "react-router-dom";
import routes from "./routes/routesAuthenticated";

function AppAuthenticatedRoutes() {
  return <RouterProvider router={routes} />;
}

export default AppAuthenticatedRoutes;
